import React, { useState } from 'react'
import { Modal, Button } from 'semantic-ui-react'
import * as R from 'ramda'

import useAxios from 'hooks/useAxios'
import { UserForm } from 'organisms/UserForm'
import usePermission from 'hooks/usePermission'
import { toast } from 'libs/toast'
import { isValidCustomLoginMethod } from 'libs/user'

export default function EditUserModalContent({
  defaultRoleValue: defaultRole,
  defaultDisableSSOValue: defaultDisableSSO,
  close,
  onEdit,
  loading: editUserLoading,
  user,
  roleOptions,
  surveyAccessSelectableRoles,
  dashbardAccessesSelectableRoles,
}) {
  /** @type {[*, function]} */
  const [userState, setUserState] = useState({})
  const surveyAccessesAxiosObject = useAxios({
    url: `account/accounts/${user.id}/control-survey-access/`,
  })
  const { data: dashbardAccesses, loading: fetcingDashboardAccess } = useAxios({
    url: `account/accounts/${user.id}/control-dashboard-access/`,
  })
  const { user: loggedInUser } = usePermission()

  const { data: enabledSSO } = useAxios({
    url: 'billing/plans/feature-toggle/',
    method: 'post',
    data: { feature: 'sso' },
  })

  function handleSubmit() {
    if (!isValidCustomLoginMethod(userState.is_custom_login, userState.login_methods)) {
      toast.error('At least one login method is required')
      return
    }

    onEdit(
      userState.role,
      user.id,
      userState.disable_sso,
      userState.login_methods,
      userState.is_custom_login,
      userState.surveys,
      userState.dashboards
    )
  }

  const shouldShowEditUserSurveyAccessInput = surveyAccessSelectableRoles.includes(userState.role)
  const buttonLoading =
    editUserLoading || (shouldShowEditUserSurveyAccessInput && !surveyAccessesAxiosObject.data)

  return (
    <React.Fragment>
      <Modal.Header>Edit user</Modal.Header>
      <Modal.Content>
        <UserForm
          defaultUser={user}
          defaultDisableSSO={defaultDisableSSO}
          defaultRole={defaultRole}
          defaultSurveyAccesses={surveyAccessesAxiosObject.data}
          loading={!surveyAccessesAxiosObject.data || fetcingDashboardAccess}
          onChange={setUserState}
          roleOptions={roleOptions}
          showSSOEnforcementForm={
            R.path(['enabled'], enabledSSO) &&
            loggedInUser.workos_sso_connection_status === 'active'
          }
          surveyAccessSelectableRoles={surveyAccessSelectableRoles}
          defaultDashbardAccesses={dashbardAccesses || []}
          dashbardAccessesSelectableRoles={dashbardAccessesSelectableRoles}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button primary onClick={handleSubmit} loading={buttonLoading} disabled={buttonLoading}>
          Update user
        </Button>
      </Modal.Actions>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/EditUserModalContent/index.js